import Version from 'antd/lib/version'

import 'antd/lib/version/style'

export * from 'antd/lib/version'

export default Version
